import {
  ExclamationCircleOutlined,
  StopOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { changeUserBlockStatus } from "../../Services";
import { useState } from "react";
import ReportUser from "./ReportUser";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetMessageDetaisList } from "../../ClientSideStates";

const MessageDetailOptions = () => {
  const [isShowReportModal, setIsShowReportModal] = useState(false);
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const dispatch = useDispatch()
   const { messageDetailsListData,messageDetilsFilter } = useSelector(
        (state: RootState) => state.message
      );


      
  const handleBlockUserConfirm = (status: boolean) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu Kullanıcı ${status?"engellenecek":"engellemeyi kaldırılacak"}. Onaylıyor musunuz?`,
      okText: status?"Engelle":"Engellemeyi Kaldır",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          let data = {
            description:"",
            status,
            blockingUserId:userInfoes.id,
            blockedUserId:messageDetilsFilter?.ContactUserId
          }
          await changeUserBlockStatus(data);
          const messageDetails= {...messageDetailsListData,isBlocked:status}
            dispatch(handleSetMessageDetaisList({ data: messageDetails }));
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };
  return (
    <>
      <div className="!flex items-center gap-4 !h-full !justify-center md:!justify-end !w-full">
        <div className="flex items-center gap-1 group">
          <MazakaButton
            type="text"
            className="  md:group-hover:!bg-[#ffc600] md:group-hover:!text-black md:!bg-transparent !bg-[#ffc600] !text-black !text-xs"
            icon={
              <WarningOutlined className="text-black group-hover:text-black" />
            }
            onClick={()=>{
              setIsShowReportModal(true)
            }}
          >
            Şikayet Et
          </MazakaButton>
        </div>

        <div className="flex items-center gap-1 group">
          {
            messageDetailsListData&&
            <>
          <MazakaButton
            type="text"
            className=" md:text-black md:group-hover:!bg-red-500 md:group-hover:!text-white !bg-red-500 !text-white text-xs"
            icon={
              <StopOutlined className=" group-hover:text-white" />
            }
            onClick={() => {
              handleBlockUserConfirm(!messageDetailsListData.isBlocked);
            }}
          >
            {messageDetailsListData?.isBlocked?"Engellemeyi kaldır":"Engelle"}
          </MazakaButton>
            </>
          }
        </div>
      </div>

      <Modal
        open={isShowReportModal}
        onCancel={() => {
          setIsShowReportModal(false);
        }}
        footer={false}
        title={false}
      >
        <ReportUser
          onFinish={() => {
            setIsShowReportModal(false);
          }}
        />
      </Modal>
    </>
  );
};

export default MessageDetailOptions;
